module.exports = __webpack_public_path__ + "img/12blue.49bfe464.png";